import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';

const Payments = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rowPerPage, setRowPerPage] = useState(20);

    const fetchPaymentsData = async () => {
        try {
            const response = await axios.get('https://backend.amarasinghemedicare.com/admin/paymentsDetails');
            if (response.status === 200) {
                setData(response.data);
            } else {
                console.error("Failed to fetch payments data");
            }
        } catch (error) {
            console.error("Error fetching payments data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPaymentsData();
    }, []);

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#202643',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '13px',
            },
        },
    };

    const columns = [
        { name: 'Doctor', selector: row => row.fullName },
        { name: 'Amount', selector: row => "Rs " + row.amount, sortable: true },
        // { name: 'Status', selector: row => row.status, sortable: true },
        {
            name: 'Period From',
            cell: (row) => (
                <div className='bg-blue px-3 py-1 rounded-full text-white w-max'>
                    {new Date(row.periodFrom).toLocaleDateString()}
                </div>
            ),
        },
        {
            name: 'Period To',
            cell: (row) => (
                <div className='bg-green px-3 py-1 rounded-full text-white w-max'>
                    {new Date(row.periodTo).toLocaleDateString()}
                </div>
            ),
        },
        { name: 'Paid At', selector: row => new Date(row.paidAt).toLocaleString(), sortable: true },
        // { name: 'Appointment ID', selector: row => row.appointmentId },
        // { name: 'Services ID', selector: row => row.servicesId },

    ];

    return (
        <div style={{ padding: '20px' }}>
            <DataTable
                columns={columns}
                data={data}
                progressPending={loading}
                fixedHeader
                fixedHeaderScrollHeight="80vh"
                customStyles={customStyles}
                pagination
                paginationPerPage={rowPerPage}
                paginationRowsPerPageOptions={[10, 20, 50, 100, 200]}
                onChangeRowsPerPage={(newRowsPerPage) => { setRowPerPage(newRowsPerPage) }}
            />
        </div>
    );
};

export default Payments;
